module.exports = __webpack_public_path__ + "img/yishi10.cc4bbd99.jpg";